// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const wormadam_trash: PokeData = {
  "id": 10005,
  "name": "wormadam-trash",
  "height": 5,
  "weight": 65,
  "base_experience": 148,
  "types": [
    PokeType.BUG,
    PokeType.STEEL
  ],
  "api_moves": [
    "gust",
    "tackle",
    "psybeam",
    "string-shot",
    "confusion",
    "psychic",
    "flail",
    "protect",
    "attract",
    "hidden-power",
    "silver-wind",
    "metal-sound",
    "metal-burst",
    "sucker-punch",
    "bug-buzz",
    "mirror-shot",
    "iron-head",
    "captivate",
    "bug-bite",
    "quiver-dance",
    "struggle-bug",
    "infestation"
  ],
  "moves": [
    "gust",
    "tackle",
    "string-shot",
    "psychic",
    "protect",
    "metal-sound",
    "metal-burst",
    "bug-buzz",
    "bug-bite",
    "sticky-web",
    "steel-beam",
    "meteor-mash",
    "iron-defense"
  ],
  "evolution_chain": {
    "id": 213,
    "item": null,
    "species": [
      {
        "name": "burmy",
        "order": 440,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wormadam",
        "order": 441,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 412,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      },
      {
        "name": "mothim",
        "order": 442,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 412,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "male"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 155,
    "speed": 72,
    "ability_power": 138
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
